/**
 * @param actions
 * @returns {(state) => any}
 *
 * Ex. const loading = createLoadingSelector(['Action/Type']);
 */
export const createLoadingSelector = actions => state => {
  return actions.some(action => state.loading[action]);
};
